import React from 'react';
import { Input } from '../../../../components/ui/input';
import { Textarea } from '../../../../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';
import { AiButton, Field, StreamPreview, inputCls, splitLines } from '../shared';

export const validate = (wf) => (wf.data?.intent?.intent_type ? null : 'Set the search intent (analyse with AI or pick one).');

const TYPES = ['informational', 'commercial', 'transactional', 'navigational'];

const StepIntent = ({ wf, setData, runAi, ai }) => {
  const d = wf.data?.intent || {};
  const running = ai.running && ai.action === 'intent';

  const analyse = async () => {
    const res = await runAi('intent');
    if (res) setData('intent', { ...res, ai: res, key_questions: res.key_questions || [] });
  };

  return (
    <div className="space-y-6">
      <div className="text-sm text-ink-2">
        Primary keyword: <span className="font-medium text-ink">{wf.data?.keywords?.primary_keyword || '—'}</span>
      </div>
      <AiButton onClick={analyse} running={running} label="Analyse intent with AI" runningLabel="Analysing…" testId="intent-generate-btn" />
      {running && <StreamPreview text={ai.text} label="Analysing search intent…" />}

      <div className="grid md:grid-cols-2 gap-5">
        <Field label="Intent type" required testId="intent-type-field">
          <Select value={d.intent_type || ''} onValueChange={(v) => setData('intent', { intent_type: v })}>
            <SelectTrigger className={inputCls} data-testid="intent-type-select"><SelectValue placeholder="Select…" /></SelectTrigger>
            <SelectContent>
              {TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
            </SelectContent>
          </Select>
        </Field>
        <Field label="Best content format" testId="intent-format-field">
          <Input value={d.content_format || ''} onChange={(e) => setData('intent', { content_format: e.target.value })} className={inputCls} placeholder="e.g. Step-by-step guide with a framework" />
        </Field>
      </div>
      <Field label="What the searcher wants" testId="intent-goal-field">
        <Textarea value={d.searcher_goal || ''} onChange={(e) => setData('intent', { searcher_goal: e.target.value })} rows={3} className={inputCls} data-testid="intent-goal-input" />
      </Field>
      <Field label="Questions the article must answer" hint="One per line." testId="intent-questions-field">
        <Textarea value={(d.key_questions || []).join('\n')} onChange={(e) => setData('intent', { key_questions: splitLines(e.target.value) })} rows={6} className={inputCls} />
      </Field>
      <div className="grid md:grid-cols-2 gap-5">
        <Field label="Recommended angle" testId="intent-angle-field">
          <Textarea value={d.recommended_angle || ''} onChange={(e) => setData('intent', { recommended_angle: e.target.value })} rows={3} className={inputCls} />
        </Field>
        <Field label="Avoid" testId="intent-avoid-field">
          <Textarea value={d.avoid || ''} onChange={(e) => setData('intent', { avoid: e.target.value })} rows={3} className={inputCls} />
        </Field>
      </div>
    </div>
  );
};

export default StepIntent;
